var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-show',{attrs:{"item":_vm.item}},[_c('va-field',{attrs:{"source":"name"}}),_c('va-field',{attrs:{"source":"email","type":"email"}}),_c('va-field',{attrs:{"source":"roles","type":"array"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }